import React from 'react';
import { observer } from 'mobx-react';
import { withNamespaces, Trans } from 'react-i18next';
import PropTypes from 'prop-types';

import { MainWrapper } from 'legacyComponents/styled/lib';
import { SectionHeader } from 'legacyComponents/layout/sectionHeader';
import { CardSection } from 'legacyComponents/layout/cardSection';

import { clientStore } from 'apps/client/app';

import {
  InnerWrapper,
  ActivityWrapper,
  Blured,
  Sticky,
  SidebarWrapper,
} from 'apps/home/activityFeed/styles';
import { MyActivityManager } from 'apps/home/activityFeed/myActivity/appManager';
import { ActivityCard } from 'apps/home/activityFeed/views/activityCard';
import { ProjectSidebar } from 'apps/home/activityFeed/views/projectSidebar';
import { AnnouncementSidebar } from 'apps/home/activityFeed/views/announcementSidebar';

import Header from 'apps/components/header/header';

@withNamespaces()
@observer
export class MyActivity extends React.Component {
  constructor() {
    super();
    if (!clientStore.signedInProfile) {
      clientStore.routerStore.navigate('home');
    } else {
      this.appManager = new MyActivityManager(null, {});
    }
  }

  render() {
    if (!this.appManager) {
      return null;
    }
    const { activitiesConn, SetActiveTab } = this.appManager;
    const activities = activitiesConn.arrayApp;
    return (
      <>
        <Header />
        <MainWrapper>
          <InnerWrapper>
            <ActivityWrapper>
              <Blured />
              <Sticky hasBanner={clientStore.hasBanner}>
                <SectionHeader
                  activeTab='myFeed'
                  handleTabClick={SetActiveTab}
                  tabs={[
                    ['myFeed', <Trans key='text'>My Feed</Trans>, false],
                    [
                      'globalFeed',
                      <Trans key='text'>Global Feed</Trans>,
                      false,
                    ],
                  ]}
                />
              </Sticky>
              <CardSection
                key='myActivity-section'
                title=''
                createHandler={null}
                cardApp={activities}
                CardComponent={ActivityCard}
                noDataCardType='activity'
                owner
              />
            </ActivityWrapper>
            <SidebarWrapper hasBanner={clientStore.hasBanner}>
              <AnnouncementSidebar />
              <ProjectSidebar projects={this.appManager.contributedProjects} />
              {/* <TeamSidebar /> */}
            </SidebarWrapper>
          </InnerWrapper>
        </MainWrapper>
      </>
    );
  }
}

MyActivity.propTypes = {
  t: PropTypes.func,
};
